import { HomeIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { nonAuthInstance } from "../services/axiosConfig";
import useAuth from "../hooks/useAuth";
import useLoading from "../hooks/useLoading";
import Pagination from "../components/Pagination";
import { formatDate, getCurrentDateTimeString } from "../core/Util";
import { encryptQr, getCouponList, getCouponListCount } from "../services/ api_services";
import QrGenerator from "./popup/QrGenerator";
import { utils, write } from "xlsx";

const pages = [{ name: "회원권 관리", href: "/coupon2", current: false }];

export default function Coupon() {
    const stats = [
        { id: 1, name: "총 회원권", value: "0" },
        { id: 2, name: "사용 회원권", value: "0" },
        { id: 3, name: "잔여 회원권", value: "0" },
    ];

    const pageSizes = [20, 50, 100, 10000];

    const inputCond = {
        couponNo: "",
        sourceUser: "",
        pageNumber: 0,
        pageSize: 0,
        useCode: "",
    };

    const initCouponCount = {
        total_cnt: 0,
        publish_cnt: 0,
        remain_cnt: 0,
    };

    const couponStates = [
        { id: "", title: "전체" },
        { id: "0001", title: "신규" },
        { id: "0009", title: "사용완료" },
    ];

    const { auth } = useAuth();
    const { setLoading } = useLoading();
    const [open, setOpen] = useState(false);
    const [list, setList] = useState([]);
    const [cond, setCond] = useState(inputCond);
    const [count, setCount] = useState(initCouponCount);
    const [totalCount, setTotalCount] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [pageSize, setPageSize] = useState(pageSizes[0]);
    const [showQr, setShowQr] = useState(false);
    const [data, setData] = useState(inputCond);

    const today = new Date();
    const formattedDate = `${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate()}`;
    const cancelTokenSource = useRef(null);

    /**
     * 회원권 조회 API
     * @returns
     */
    const couponList = async (condTmp) => {
        try {
            console.log("cond", cond);
            const response = await getCouponList(condTmp);
            if (response && response.status === 200 && response.data) {
                console.log("response.data: ", response.data);
                response.data.map((item) => {
                    item.source_dt = formatDate(item.source_dt);
                    return item;
                });

                setList(response.data);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };

    const fetchCouponListCount = async (cond) => {
        try {
            console.log("🚀 ~ getCouponListCount ~ cond:", cond);
            const response = await getCouponListCount(cond);
            console.log("🚀 ~ getCouponListCount ~ response:", response);
            if (response && response.status === 200 && response.data) {
                console.log("response.data: ", response.data);
                setTotalCount(response.data);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };

    /**
     * 쿠폰 카운트 API
     * @returns
     */
    const couponCount = async () => {
        try {
            let condTmp = cond;
            condTmp.sourceUser = auth.admin_seq;
            condTmp.pageNumber = currentPage;
            condTmp.pageSize = pageSize;
            const response = await nonAuthInstance.post("coupon/totalCount", condTmp);
            if (response.status === 200) {
                console.log("Coupon count response.data: ", response.data);
                setCount(response.data);
            }
        } catch (e) {
            console.log("e===>", e);
        }
    };

    useEffect(() => {
        couponCount();
    }, []);

    useEffect(() => {
        // console.log("currentPage", currentPage);
        onSearch();
    }, [currentPage, pageSize]);

    /**
     * 회원권 조회 함수
     * @returns
     */
    async function onSearch() {
        console.warn("START onSearch ==>");
        setLoading(true);
        // let currentVal = currentPage > 0 ? currentPage - 1 : currentPage;
        let condTmp = cond;
        condTmp.sourceUser = auth.admin_seq;

        
        fetchCouponListCount(condTmp);

        condTmp.pageNumber = currentPage;
        condTmp.pageSize = pageSize;
        console.log("currentPage==>", currentPage);
        console.log("pageSize==>", pageSize);
        console.log("🚀 ~ onSearch ~ condTmp:", condTmp);

        couponList(condTmp);
        
        // await couponCount(condTmp);
        setLoading(false);
    }

    /**
     * 엔터키 이벤트
     * @returns
     */
    const handleOnKeyPress = (e) => {
        if (e.key === "Enter") {
            onSearch(); // Enter 입력이 되면 클릭 이벤트 실행
        }
    };

    const handleOnSelectPageSize = (pageSize) => {
        console.log("🚀 ~ handleOnSelectPageSize ~ pageSize:", pageSize);
        // console.log("🚀 ~ handleOnSelectPageSize ~ pageSize:", Number(pageSize));
        setPageSize(Number(pageSize));
    };

    const handleOnSelectCouponState = (index) => {
        // console.log("🚀 ~ handleOnSelectCouponState ~ state:", index);
        console.log("🚀 ~ handleOnSelectCouponState ~ id:", couponStates[index].id);
        setCond((preVal) => {
            return {
                ...preVal,
                useCode: couponStates[index].id,
            };
        });
    };

    const handleOnDoubleClickGridRow = async (e, data) => {
        console.log("🚀 ~ handleOnDoubleClickGridRow ~ data:", data);
        setData(data);
        setShowQr(true);
    }

    const onToExcel = () => {
        if (list.length === 0) {
            alert("다운 받을 데이터가 없습니다");
            return;
        }

        let ws;
        let testName = "회원권 관리";

        let i = 0;
        const fixedData = list.map((row) => ({
            NO: i+=1,
            회원권번호: row.coupon_no,
            생성일: row.source_dt,
            보낸회원: row.source_user,
            보낸회원이름: row.source_user_nm,
            받은회원: row.target_user,
            받은회원이름: row.target_user_nm,
            회원권코드: row.use_code,
            회원권상태: row.spec_nm,
            QR코드: row.qr_txt,
        }));

        ws = utils.json_to_sheet(fixedData);

        const wb = utils.book_new();
        utils.book_append_sheet(wb, ws, "Sheet1");
        const excelBuffer = write(wb, { bookType: "xlsx", type: "array" });
        const blob = new Blob([excelBuffer], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const fileName =
            getCurrentDateTimeString() + "_" + testName + "_" + ".xlsx";
    
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
    };

    async function onEncryptQr() {
        const isConfirmed = window.confirm("QR 암호화를 시작하시겠습니까?");

        if (isConfirmed) {
            setLoading(true);
            const response = await encryptQr();
            console.log(response);
            
            if (response.data.resultCode === 204 || response.data.resultCode === 200) {
                alert(response.data.message);
            }
            setLoading(false);
        }
    };

    const calculateShowingStartIndex = () => (currentPage - 1) * pageSize + 1;

    return (
        <div>
            <nav className="flex border-b border-gray-200 bg-white -mx-8 -mt-6 w-full" aria-label="Breadcrumb">
                <ol className=" flex w-full max-w-screen-xl space-x-4 px-4 sm:px-6 lg:px-8">
                    <li className="flex">
                        <div className="flex items-center">
                            <a href="/" className="text-gray-400 hover:text-gray-500">
                                <HomeIcon className="h-5 w-5 flex-shrink-0" aria-hidden="true" />
                                <span className="sr-only">Home</span>
                            </a>
                        </div>
                    </li>
                    {pages.map((page) => (
                        <li key={page.name} className="flex">
                            <div className="flex items-center">
                                <svg
                                    className="h-full w-6 flex-shrink-0 text-gray-200"
                                    viewBox="0 0 24 44"
                                    preserveAspectRatio="none"
                                    fill="currentColor"
                                    aria-hidden="true"
                                >
                                    <path d="M.293 0l22 22-22 22h1.414l22-22-22-22H.293z" />
                                </svg>
                                <a
                                    href={page.href}
                                    className="ml-4 text-sm font-medium text-gray-500 hover:text-gray-700"
                                    aria-current={page.current ? "page" : undefined}
                                >
                                    {page.name}
                                </a>
                            </div>
                        </li>
                    ))}
                </ol>
            </nav>
            <div className=" bg-gray-900 max-w-full mt-2 max-h-full">
                <div className="mx-auto max-w-full">
                    <div className="bg-gray-900 py-10">
                        <div className="px-4 sm:px-6 lg:px-8">
                            <dl className="mx-auto mt-8 mb-8 grid max-w-2xl grid-cols-1 gap-x-12 gap-y-16 text-white sm:mt-8 sm:grid-cols-4 sm:gap-y-16 lg:mx-0 lg:max-w-none lg:grid-cols-4">
                                {stats.map((stat) => (
                                    <div key={stat.id} className="flex flex-col gap-y-3 border-l border-white/10 pl-6">
                                        <dt className="text-sm leading-6">{stat.name}</dt>
                                        <dd className="order-first text-3xl font-semibold tracking-tight">
                                            {stat.id === 1 ? count?.user_total_cnt?.toLocaleString?.() ?? '0' : stat.id === 2 ? count?.user_use_cnt?.toLocaleString?.() ?? '0' : count?.user_remain_cnt?.toLocaleString?.() ?? '0'}
                                        </dd>
                                    </div>
                                ))}
                            </dl>

                            <div className="mt-6 mb-6 w-full">
                                <div className="flex flex-wrap md:flex-nowrap gap-3 md:gap-4 w-full items-center justify-between">
                                    {/* 회원권 번호 검색 */}
                                    <div className="w-full md:w-64 min-w-[400px]">
                                    <input
                                        type="search"
                                        placeholder="회원권 번호, 보낸 회원 또는 받은 회원을 입력해주세요"
                                        className="block w-full rounded-md border-0 px-3.5 py-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm"
                                        onChange={e =>
                                        setCond(preVal => ({
                                            ...preVal,
                                            couponNo: e.target.value,
                                        }))
                                        }
                                        onKeyDown={handleOnKeyPress}
                                    />
                                    </div>
                                    <button
                                        type="button"
                                        className="rounded-md bg-white w-full md:w-20 py-2 text-sm font-semibold text-gray-900 shadow-md hover:bg-gray-700 transition"
                                        onClick={onSearch}
                                    >
                                    검색
                                    </button>

                                    {/* 회원권 상태 */}
                                    <div className="flex items-center space-x-2 w-full md:w-56">
                                        <label className="w-20 text-start text-sm font-medium text-gray-300">회원권 상태</label>
                                        <select
                                            id="location"
                                            name="location"
                                            className="w-full md:w-32 rounded-md border-0 py-1.5 pl-3 pr-10 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                            defaultValue={couponStates && couponStates[0].title}
                                            onChange={e => handleOnSelectCouponState(e.target.selectedIndex)}
                                        >
                                            {couponStates.map(item => (
                                                <option key={item.title}>{item.title}</option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* 조회 개수 */}
                                    <div className="flex items-center space-x-2 w-full md:w-44">
                                    <label className="text-start text-sm font-medium text-gray-300">조회 개수</label>
                                    <select
                                        id="pageSize"
                                        name="pageSize"
                                        className="block w-full md:w-24 rounded-md border-0 py-1.5 pl-3 pr-6 text-gray-900 ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-indigo-600 sm:text-sm"
                                        defaultValue={pageSizes && pageSizes[0]}
                                        onChange={e => handleOnSelectPageSize(e.target.value)}
                                    >
                                        {pageSizes.map(item => (
                                            <option key={item}>{item}</option>
                                        ))}
                                    </select>
                                    </div>

                                    {/* 엑셀 버튼 */}
                                    <button
                                        type="button"
                                        className="rounded-md bg-emerald-500 w-full md:w-20 py-2 text-sm font-semibold text-white shadow-md hover:bg-emerald-600 transition"
                                        onClick={onToExcel}
                                    >
                                    엑셀
                                    </button>

                                    {/* QR 암호화 버튼 */}
                                    <button
                                        type="button"
                                        className="rounded-md bg-indigo-500 w-full md:w-24 py-2 text-sm font-semibold text-white shadow-md hover:bg-indigo-600 transition"
                                        onClick={onEncryptQr}
                                    >
                                    QR 암호화
                                    </button>
                                </div>
                            </div>


                            <div className="mt-1 flow-root">
                                <div className="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                                    <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
                                        <table className="min-w-full divide-y divide-gray-700">
                                            <thead>
                                                <tr>
                                                    <th scope="col" className="w-3 py-3.5 pl-4 pr-3 text-center text-sm font-semibold text-white sm:pl-0">
                                                        NO
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        회원권번호
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        생성일
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        보낸 회원
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        받은 회원
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        회원권 상태
                                                    </th>
                                                    <th scope="col" className="px-3 py-3.5 text-center text-sm font-semibold text-white">
                                                        QR 코드
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="divide-y divide-gray-800">
                                                {list &&
                                                    list.map((data, index) => (
                                                        <tr
                                                        // className="hover:bg-slate-800"
                                                        //key={person.email}
                                                        onDoubleClick={(e) =>
                                                            handleOnDoubleClickGridRow(e, data)
                                                        }
                                                        >
                                                            <td className="w-3 whitespace-nowrap py-4 text-left pl-4 pr-3 text-sm font-medium text-white sm:pl-0">
                                                                {calculateShowingStartIndex() + index}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                {data.coupon_no}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                {data.source_dt}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-300">
                                                                {data.target_user_nm}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 text-center py-4 text-sm text-gray-300">
                                                                {data.source_user_nm}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                {data.spec_nm}
                                                            </td>
                                                            <td className="whitespace-nowrap px-3 py-4 text-center text-sm text-gray-300">
                                                                {data.qr_txt?'Y':'N'}
                                                            </td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Pagination
                onChangeCurrentPage={(val) => setCurrentPage(val)}
                onChangeTotalPages={(val) => setTotalPages(val)}
                totalCount={totalCount}
                itemsPerPage={pageSize}
                // onPageChange={handleOnPageChange}
            />
            {
                showQr && !!data?.qr_txt &&(
                <QrGenerator 
                    isOpen={showQr} 
                    onClose={() => setShowQr(false)}
                    data={data}
                />)
            }
        </div>
    );
}
